import React, {useCallback, useEffect, useState} from 'react'
import {connect} from '@modifi/redux'
import {
  existingFilesListComponents,
  fileEntryComponents,
  aCustomerFetchFile,
  FileStatus,
} from '@modifi/plugin-documents'
import {withProgress, DangerAlert} from '@modifi/ui'
import {aOpenFile} from './store'

// @TOODO THIS SHOULD BE REMOVED ONCE DOC "CANDELETEDOCUMENT" issue is resolved
// Ideally import should not happen outside of plugins folder
import {selectDocumentsById} from '../../../../../../../data/company-documents'

const FileCta = (props: {documentType: string; fileId: string}) => (
  <fileEntryComponents.FileCta {...props} />
)

const FileEntry = ({
  components,
  openFile,
  fetchFile,
  progressStart,
  progressDone,
  progress,
  fileInfo,
  canDeleteDocument,
  ...props
}: any) => {
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [downloadError, setDownloadError] = useState(null)

  useEffect(() => {
    if (downloadLoading) {
      progressStart()
    } else {
      progressDone()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadLoading])

  const handleOnDocClick = useCallback(
    async (docInfo: any) => {
      let fileOpenError = ''
      let fileOpenResponse
      if (downloadError) setDownloadError(null)
      setDownloadLoading(true)
      try {
        fileOpenResponse = await openFile(docInfo?.fileId)
      } catch (error) {
        // @ts-expect-error to be fixed
        fileOpenError = error?.responseData
      }
      if (fileOpenError || fileOpenResponse.status !== 'success') {
        try {
          await fetchFile(docInfo?.fileId, docInfo?.fileName, docInfo?.mimeType)
        } catch (errorOnDownload) {
          // @ts-expect-error to be fixed
          setDownloadError(errorOnDownload?.responseData || '')
        }
      }
      setDownloadLoading(false)
    },
    [openFile, fetchFile, downloadError]
  )

  return (
    <>
      <existingFilesListComponents.FileEntry
        {...props}
        canDeleteDocument={
          typeof fileInfo?.canDelete !== 'undefined' ? fileInfo?.canDelete : canDeleteDocument
        }
        preventDownload
        onClick={downloadLoading ? null : handleOnDocClick}
        components={{fileCta: FileCta, ...components}}
        // when progress is 100 i.e. complete we pass null so that progress bar doesn't occupy space
        // which is dependent on whether progress exist or not
        progress={progress === 100 ? null : progress}
        status={downloadLoading ? FileStatus.LOADING : null}
      />
      {downloadError && <DangerAlert>{downloadError}</DangerAlert>}
    </>
  )
}

const mapStateToProps = (state: Record<string, any>, ownProps: {fileId: string}) => ({
  fileInfo: selectDocumentsById(state, ownProps?.fileId),
})

const mapDispatchToProps = {
  openFile: aOpenFile,
  fetchFile: aCustomerFetchFile,
}

const ConnectedFileEntry = connect(mapStateToProps, mapDispatchToProps)(FileEntry)

export default withProgress({autoStart: false})(ConnectedFileEntry)
